import React from 'react';
import Immutable from 'immutable';
import { useSelector } from 'react-redux';

import Breadcrumbs from '../Breadcrumbs';

// This is a base implementation of the RDC breadcrumbs.
// There is a ticket on the board for moving to the full RDC implementation.
// https://uncinc.monday.com/boards/1506051082/pulses/6354030674.
const BreadcrumbsFromMenu = ({ data = [] }) => {
  const breadcrumbs = useSelector((state) => state.getIn(['entity', 'breadcrumbs'], Immutable.List()));

  const { currentTitle } = useSelector((state) => {
    const entityId = state.getIn(['entity', 'entityId']);
    const entityType = state.getIn(['entity', 'entityType']);
    const entity = state.getIn([entityType, entityId]);

    if (!entity) {
      return { currentTitle: null, currentUrl: null };
    }

    const title = entity.getIn(['title', 0, 'value']);

    return { currentTitle: title };
  });

  // Collect our data and remove the homepage entry from the dataset.
  const breadcrumbsData = breadcrumbs.toJS().slice(1).concat({
    title: currentTitle,
  });

  return (
    <div className="BreadcrumbsFromMenu">
      <Breadcrumbs
        data={data.length === 0 ? breadcrumbsData : data}
      />
    </div>
  );
};

export default BreadcrumbsFromMenu;
